import React, { useState, useEffect, useMemo } from "react";
import {
  Row,
  Col,
  Card,
  CardBody,
  CardHeader,
  Button,
  Input,
  Badge,
  Pagination,
  PaginationItem,
  PaginationLink,
  Alert,
  Spinner,
  Container
} from "reactstrap";
import {
  useTable,
  usePagination,
  useGlobalFilter,
  useSortBy,
} from "react-table";
import { API_WEB_URLS } from "../../constants/constAPI";
import { useDispatch } from "react-redux";
import { Fn_FillListData, Fn_DeleteData } from "../../store/Functions";
import { useNavigate } from "react-router-dom";

const PageList_BrokerMaster = () => {
  const [gridData, setGridData] = useState([]);
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const rtPage_Add = "/AddBroker";
  const rtPage_Edit = "/EditBroker";
  const API_URL = API_WEB_URLS.MASTER + "/0/token/BrokerAccountEdit";

  const DeleteAPI_URL = API_WEB_URLS.MASTER + "/0/token/DeleteBrokerMaster";

  const [state, setState] = useState({
    id: 0,
    FillArray: [],
    formData: {},
    OtherDataScore: [],
    isProgress: true,
  });

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      await Fn_FillListData(dispatch, setGridData, "gridData", API_URL + "/Id/0");
      setLoading(false);
    };

    fetchData();
  }, [dispatch, API_URL]);

  const btnAddOnClick = () => {
    navigate(rtPage_Add, { state: { Id: 0 } });
  };

  const btnEditOnClick = (Id) => {
    navigate(rtPage_Edit, { state: { Id } });
  };

  const btnDeleteOnClick = (Id) => {
    Fn_DeleteData(dispatch, setState, Id, `${DeleteAPI_URL}`, true)
  };

  const data = useMemo(() => gridData || [], [gridData]);

  const columns = useMemo(
    () => [
      {
        Header: "Sr",
        accessor: (row, i) => i + 1,
        disableSortBy: true,
        width: 40,
        Cell: ({ value }) => (
          <span className="text-dark fw-semibold" style={{ fontSize: '11px' }}>{value}</span>
        ),
      },
      {
        Header: "Name",
        accessor: "Name",
        width: 120,
        Cell: ({ value }) => (
          <span className="text-dark" style={{ fontSize: '11px' }} title={value}>{value?.length > 15 ? value.substring(0, 15) + '...' : value}</span>
        ),
      },
      {
        Header: "Person",
        accessor: "Person",
        width: 100,
        Cell: ({ value }) => (
          <span className="text-dark" style={{ fontSize: '11px' }} title={value}>{value?.length > 12 ? value.substring(0, 12) + '...' : value}</span>
        ),
      },
      {
        Header: "Address",
        accessor: "Address",
        width: 120,
        Cell: ({ value }) => (
          <span className="text-dark" style={{ fontSize: '11px' }} title={value}>{value?.length > 15 ? value.substring(0, 15) + '...' : value}</span>
        ),
      },
      {
        Header: "City",
        accessor: "City",
        width: 80,
        Cell: ({ value }) => (
          <span className="text-dark" style={{ fontSize: '11px' }} title={value}>{value?.length > 10 ? value.substring(0, 10) + '...' : value}</span>
        ),
      },
      {
        Header: "State",
        accessor: "State",
        width: 80,
        Cell: ({ value }) => (
          <span className="text-dark" style={{ fontSize: '11px' }} title={value}>{value?.length > 10 ? value.substring(0, 10) + '...' : value}</span>
        ),
      },
      {
        Header: "IFS",
        accessor: "IFS",
        width: 80,
        Cell: ({ value }) => (
          <span className="text-dark" style={{ fontSize: '11px' }}>{value}</span>
        ),
      },
      {
        Header: "PAN",
        accessor: "PanNo",
        width: 90,
        Cell: ({ value }) => (
          <span className="text-dark" style={{ fontSize: '11px' }}>{value}</span>
        ),
      },
      {
        Header: "Phone",
        accessor: "PhoneNo",
        width: 90,
        Cell: ({ value }) => (
          <span className="text-dark" style={{ fontSize: '11px' }}>{value}</span>
        ),
      },
      {
        Header: "Mobile",
        accessor: "MobileNo",
        width: 90,
        Cell: ({ value }) => (
          <span className="text-dark" style={{ fontSize: '11px' }}>{value}</span>
        ),
      },
      {
        Header: "Email",
        accessor: "email",
        width: 120,
        Cell: ({ value }) => (
          <span className="text-dark" style={{ fontSize: '11px' }} title={value}>{value?.length > 15 ? value.substring(0, 15) + '...' : value}</span>
        ),
      },
      {
        Header: "Fax",
        accessor: "Fax",
        width: 80,
        Cell: ({ value }) => (
          <span className="text-dark" style={{ fontSize: '11px' }}>{value}</span>
        ),
      },
      {
        Header: "GST",
        accessor: "GSTNo",
        width: 100,
        Cell: ({ value }) => (
          <span className="text-dark" style={{ fontSize: '11px' }} title={value}>{value?.length > 12 ? value.substring(0, 12) + '...' : value}</span>
        ),
      },
      {
        Header: "A/C No",
        accessor: "AccNo",
        width: 100,
        Cell: ({ value }) => (
          <span className="text-dark" style={{ fontSize: '11px' }} title={value}>{value?.length > 12 ? value.substring(0, 12) + '...' : value}</span>
        ),
      },
      {
        Header: "Actions",
        accessor: "Id",
        disableSortBy: true,
        width: 120,
        Cell: ({ value }) => (
          <div className="d-flex gap-1 justify-content-center">
            <Button
              color="primary"
              size="sm"
              onClick={() => btnEditOnClick(value)}
              className="px-1 py-0"
              style={{
                borderRadius: '3px',
                fontSize: '9px',
                lineHeight: '1.2'
              }}
            >
              Edit
            </Button>
            <Button
              color="danger"
              size="sm"
              onClick={() => btnDeleteOnClick(value)}
              className="px-1 py-0"
              style={{
                borderRadius: '3px',
                fontSize: '9px',
                lineHeight: '1.2'
              }}
            >
              Del
            </Button>
          </div>
        ),
      },
    ],
    []
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    state: { pageIndex, pageSize, globalFilter },
    setGlobalFilter,
  } = useTable(
    {
      columns,
      data,
      initialState: { pageIndex: 0, pageSize: 15 },
    },
    useGlobalFilter,
    useSortBy,
    usePagination
  );

  const renderPagination = () => {
    const paginationItems = [];
    const maxVisiblePages = 5;
    let startPage = Math.max(0, pageIndex - Math.floor(maxVisiblePages / 2));
    let endPage = Math.min(pageCount - 1, startPage + maxVisiblePages - 1);

    if (endPage - startPage + 1 < maxVisiblePages) {
      startPage = Math.max(0, endPage - maxVisiblePages + 1);
    }

    // Previous button
    paginationItems.push(
      <PaginationItem key="prev" disabled={!canPreviousPage}>
        <PaginationLink onClick={() => previousPage()} href="#">
          <i className="fas fa-chevron-left"></i>
        </PaginationLink>
      </PaginationItem>
    );

    // Page numbers
    for (let i = startPage; i <= endPage; i++) {
      paginationItems.push(
        <PaginationItem key={i} active={i === pageIndex}>
          <PaginationLink onClick={() => gotoPage(i)} href="#">
            {i + 1}
          </PaginationLink>
        </PaginationItem>
      );
    }

    // Next button
    paginationItems.push(
      <PaginationItem key="next" disabled={!canNextPage}>
        <PaginationLink onClick={() => nextPage()} href="#">
          <i className="fas fa-chevron-right"></i>
        </PaginationLink>
      </PaginationItem>
    );

    return paginationItems;
  };

  if (loading) {
    return (
      <div className="page-content" >
        <div className="container-fluid">
          <div className="d-flex justify-content-center align-items-center" style={{ height: '60vh' }}>
            <div className="text-center">
              <Spinner color="primary" size="lg" className="mb-3">
                Loading...
              </Spinner>
              <p className="text-muted">Loading broker data...</p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div   >
      <div className="container-fluid" style={{ maxWidth: '100%', padding: '0', overflow: 'hidden' }}>
        {/* Page Header */}
        <div className="row mb-3">
          <div className="col-12">
            <div className="page-title-box d-flex align-items-center justify-content-between">
              <h4 className="mb-0 text-primary fw-semibold" style={{ fontSize: '16px' }}>
                <i className="fas fa-handshake me-2" style={{ fontSize: '14px' }}></i>
                Broker Master
              </h4>
              <div className="page-title-right">
                <ol className="breadcrumb m-0">
                  <li className="breadcrumb-item">
                    <a href="#" className="text-muted" style={{ fontSize: '12px' }}>Masters</a>
                  </li>
                  <li className="breadcrumb-item active" style={{ fontSize: '12px' }}>Broker List</li>
                </ol>
              </div>
            </div>
          </div>
        </div>

        {/* Main Content Card */}
        <Row>
          <Col lg="12">
            <Card className="shadow-sm border-0" style={{ minHeight: 'calc(100vh - 150px)' }}>
              <CardHeader className="bg-primary text-white py-3">
                <div className="d-flex justify-content-between align-items-center">
                  <h5 className="mb-0 fw-semibold" style={{ fontSize: '14px' }}>
                    <i className="fas fa-list me-2" style={{ fontSize: '12px' }}></i>
                    Broker List
                  </h5>
                  <Button
                    color="light"
                    size="sm"
                    onClick={btnAddOnClick}
                    className="fw-semibold"
                    style={{
                      borderRadius: '6px',
                      border: '1px solid rgba(255,255,255,0.3)',
                      transition: 'all 0.3s ease',
                      fontSize: '12px'
                    }}
                  >
                    <i className="fas fa-plus me-2" style={{ fontSize: '10px' }}></i>
                    Add New Broker
                  </Button>
                </div>
              </CardHeader>
              <CardBody className="p-4">
                {/* Search Section */}
                <Row className="mb-2">
                  <Col lg="6" md="8" sm="12" className="mb-1">
                    <div className="search-box position-relative">
                      <Input
                        type="text"
                        className="form-control form-control-lg border-2"
                        placeholder="Search ..."
                        value={globalFilter || ""}
                        onChange={(e) => setGlobalFilter(e.target.value)}
                        style={{
                          borderRadius: '8px',
                          paddingLeft: '45px',
                          borderColor: '#e9ecef',
                          transition: 'all 0.3s ease',
                          fontSize: '13px'
                        }}
                      />
                      <i 
                        className="fas fa-search position-absolute"
                        style={{
                          left: '15px',
                          top: '50%',
                          transform: 'translateY(-50%)',
                          color: '#6c757d',
                          zIndex: 10,
                          fontSize: '12px'
                        }}
                      ></i>
                    </div>
                  </Col>
                </Row>

                {/* Data Table */}
                {data.length === 0 ? (
                  <Alert color="info" className="text-center">
                    <i className="fas fa-info-circle me-2" style={{ fontSize: '12px' }}></i>
                    <span style={{ fontSize: '13px' }}>No broker data available.</span>
                  </Alert>
                ) : (
                  <>
                    <div style={{ 
                      width: '100%',
                      overflowX: 'auto',
                      overflowY: 'auto',
                      maxHeight: '500px',
                      border: '1px solid #dee2e6'
                    }}>
                      <table {...getTableProps()} className="table table-striped table-bordered mb-0" style={{ 
                        width: '100%',
                        tableLayout: 'fixed',
                        minWidth: '1200px'
                      }}>
                        <thead className="table-dark sticky-top">
                          {headerGroups.map((headerGroup, headerGroupIndex) => (
                            <tr {...headerGroup.getHeaderGroupProps()} key={headerGroupIndex}>
                              {headerGroup.headers.map((column, columnIndex) => (
                                <th 
                                  {...column.getHeaderProps(column.getSortByToggleProps())} 
                                  key={columnIndex}
                                  className="text-center fw-semibold"
                                  style={{ 
                                    cursor: column.canSort ? 'pointer' : 'default',
                                    fontSize: '11px',
                                    padding: '6px 2px',
                                    whiteSpace: 'nowrap',
                                    width: column.width || 'auto',
                                    backgroundColor: '#212529'
                                  }}
                                >
                                  {column.render("Header")}
                                  {column.canSort && (
                                    <span className="ms-1">
                                      {column.isSorted ? (
                                        column.isSortedDesc ? (
                                          <i className="fas fa-sort-down" style={{ fontSize: '9px' }}></i>
                                        ) : (
                                          <i className="fas fa-sort-up" style={{ fontSize: '9px' }}></i>
                                        )
                                      ) : (
                                        <i className="fas fa-sort" style={{ fontSize: '9px' }}></i>
                                      )}
                                    </span>
                                  )}
                                </th>
                              ))}
                            </tr>
                          ))}
                        </thead>
                        <tbody {...getTableBodyProps()}>
                          {page.map((row, rowIndex) => {
                            prepareRow(row);
                            return (
                              <tr {...row.getRowProps()} key={rowIndex} className="align-middle">
                                {row.cells.map((cell, cellIndex) => (
                                  <td {...cell.getCellProps()} key={cellIndex} className="text-center" style={{ 
                                    padding: '4px 2px',
                                    fontSize: '11px',
                                    whiteSpace: 'nowrap',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    width: cell.column.width || 'auto'
                                  }}>
                                    {cell.render("Cell")}
                                  </td>
                                ))}
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>

                    {/* Pagination and Page Size Controls */}
                    <div className="d-flex justify-content-between align-items-center mt-4">
                      <div className="d-flex align-items-center gap-3">
                        <div className="text-muted" style={{ fontSize: '12px' }}>
                          Showing {pageIndex * pageSize + 1} to {Math.min((pageIndex + 1) * pageSize, data.length)} of {data.length} records
                        </div>
                        <div className="d-flex align-items-center gap-2">
                          <span className="text-muted" style={{ fontSize: '12px' }}>Show:</span>
                          <select
                            value={pageSize}
                            onChange={(e) => setPageSize(Number(e.target.value))}
                            className="form-select form-select-sm"
                            style={{ width: 'auto', fontSize: '12px' }}
                          >
                            {[10, 15, 20, 30, 50].map((size) => (
                              <option key={size} value={size}>
                                {size}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                      {pageCount > 1 && (
                        <Pagination className="mb-0">
                          {renderPagination()}
                        </Pagination>
                      )}
                    </div>
                  </>
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default PageList_BrokerMaster;

